import { PercentageSmallCircleFillIcon } from '@zep-us/zus-icons';
import { QUOTE_BULLET_ORDER, TrialEndDiscountBullets } from '@/module/plan/components/TrialEndDiscountBullets';
import { type TrialEndQuoteDiscount } from '../utils/quoteCalculator';
import { formatDiscountRate } from '../utils/quoteFormat';

/**
 * 견적 우측 "20% 할인 혜택을 적용 중이에요" 카드 (Figma 29114:7245).
 * 할인이 실제로 적용될 때만 노출한다 — 미적용 상태에서 띄우면 단체 할인 유도와 충돌한다.
 */
export function TrialEndDiscountNotice({
  discount
}: {
  discount: TrialEndQuoteDiscount;
}) {
  return <div className="flex w-full flex-col gap-sm rounded-sm border border-solid border-alternative bg-white p-md shadow-xs" data-sentry-component="TrialEndDiscountNotice" data-sentry-source-file="TrialEndDiscountNotice.tsx">
      <div className="flex items-start gap-xs">
        <span className="flex shrink-0 items-center pt-[2px]">
          <PercentageSmallCircleFillIcon size="sm" fill="#F268F5" data-sentry-element="PercentageSmallCircleFillIcon" data-sentry-source-file="TrialEndDiscountNotice.tsx" />
        </span>
        <div className="flex flex-col justify-center gap-xs">
          <p className="text-body-lg-semibold text-default">
            <span className="text-[#F268F5]">
              {formatDiscountRate(discount.discountRate)} 할인{' '}
            </span>
            혜택을 적용 중이에요
          </p>
          <TrialEndDiscountBullets order={QUOTE_BULLET_ORDER} maxUserCount={discount.maxUserCount} maxMonthCount={discount.maxMonthCount} data-sentry-element="TrialEndDiscountBullets" data-sentry-source-file="TrialEndDiscountNotice.tsx" />
        </div>
      </div>
    </div>;
}